import React from 'react';
import { Button, Modal, Text } from '@fragments';
import { IconCheck, IconCalendar, IconBrandWhatsapp, IconArrowUpRight } from '@tabler/icons-react';
import { supportWhatsApp } from '@config';
import FeatureIllustration from './components/FeatureIllustration';
import './styles.scss';

const RELEASE_DATE = '2027-01-05T12:00:00Z';

// The illustration is the modal's backdrop: it bleeds under the whole glass
// surface, and the body keeps an empty, labelled area where its stage sits.
export default function FeaturePreview({ studio: s, feature }) {
  const { t } = s;
  const locale = s.locale.replace('_', '-');
  const release = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' }).format(new Date(RELEASE_DATE));
  const contact = () => {
    const message = t('featureBetaMessage', { feature: t(feature) });
    window.open(`https://wa.me/${supportWhatsApp.replace(/\D/g, '')}?text=${encodeURIComponent(message)}`, '_blank', 'noopener,noreferrer');
  };
  return <Modal open variant="flat" size={960} closeLabel={t('close')} onClose={() => s.setModal(null)} aria-labelledby="studio-feature-title" className="studio-dialog studio-glass-dialog studio-feature-dialog"
    backdrop={<div className="studio-feature-preview__scene"><FeatureIllustration feature={feature} t={t} locale={locale} /></div>}>
    <div className="studio-feature-preview">
      <div className="studio-feature-preview__content">
        <Text.subheading contrast={6}>{t('newFeature')}</Text.subheading>
        <Text.h2 id="studio-feature-title" contrast={9} weight={400}>{t(feature)}</Text.h2>
        <Text.p contrast={7}>{t(`feature_${feature}_description`)}</Text.p>
        <ul className="studio-feature-preview__capabilities">{[1,2,3].map(n => <li key={n}><IconCheck aria-hidden="true" /><Text.p contrast={8}>{t(`feature_${feature}_${n}`)}</Text.p></li>)}</ul>
        <div className="studio-feature-preview__release"><Text.caption contrast={6} left={<IconCalendar />}>{t('featureRelease')}</Text.caption><Text.p contrast={9}><time dateTime="2027-01-05">{release}</time></Text.p></div>
        <Button variant="rounded" color="inverse" startIcon={<IconBrandWhatsapp />} endIcon={<IconArrowUpRight />} onClick={contact}>{t('featureCta')}</Button>
        <Text.caption contrast={6}>{t('featureBetaHint')}</Text.caption>
      </div>
      <div className="studio-feature-preview__visual" role="img" aria-label={t(`feature_${feature}_art`)}>
        <Text.caption className="studio-feature-preview__tagline" contrast={6}>{t('featurePreview')}</Text.caption>
      </div>
    </div>
  </Modal>;
}
